import _ from "lodash";
import i18n from "../i18n";
import { nutritionEmptyData } from "../views/sampleValue.js";

export default {
    getDrawerState(state) {
        return state.drawer;
    },
    getUser(state) {
        return state.user
    },
    isAdminUser(state) {
        return state.user._admin_ || false;
    },
    getProfile(state) {
        return _.isEmpty(state.Profile) ? {
                                    name: "",
                                    valueScale:'Kilogram',
                                    currency: 'EUR',
                                    language: 'English',
                                    terms: false,
                                    logoURL: "",
                                    nextRecipeNo: 100
                                } :
                                state.Profile;

    },
    getCurrencyList(state) {
        return Object.keys(state.currencyList);
    },
    getCurrency(state) {
        return state.Profile.currency;
    },
    getCurrencySymbol(state) {
        return state.currencyList[state.Profile.currency] || "€";
    },
    getSeparator(state) {
        return state.Profile.separator || ";";
    },
    getFeeds(state) {
        return(search) => {
            var _feeds =  _.orderBy(state.Feeds, ['code'], ['asc']);
            return _feeds
            .filter(f => (f.active || search ))
            .filter(f => (!search ||
                        (f.code + f.name + (f.translatedFeedType || f.feedType) )
                        .toLowerCase().includes(search.toLowerCase()) ));
        }
    },

    getFeedsForDD(state) {
        return state.Feeds.sort((feedA, feedB) => {
            return feedA.code < feedB.code ? -1 : feedA.code > feedB.code ?  1 : 0;
        })
        .map(function(x) {
            return { text: x.code + " - " + x.name, value: x.Id }
        });
    },

    getFeed(state) {
        return (FeedId) => {
            if (FeedId)
                return state.Feeds.find((f) => {
                    return f.Id === FeedId
                });
            else
                return {
                    "Id": null,
                    "code": null,
                    "name": "",
                    "active": true,
                    "feedType": "unspecified",
                    "dryMaterial": 90,
                    "value": 1,
                    "tolerance": 35,
                    "manLoad": false
                };
        }
    },
    getInvCount(state) {
        return state.invCount ? state.invCount.list : [];
    },
    getTMRs(state) {
        return state.TMRs.sort((t1, t2) => {
                return t1.code < t2.code ? -1 : t1.code > t2.code ?  1 : 0;
            })
    },
    getTMRsSearch(state) {
        return(search) => {
            return state.TMRs.sort((t1, t2) => {
                return t1.code < t2.code ? -1 : t1.code > t2.code ?  1 : 0;
            })
            .filter(t1 => (!t1.inactive || search ))
            .filter(t1 => (!search || (t1.code + t1.name +
                           t1.feeds.reduce((s, f) => s + f.code + ' ' + f.name + ' ')
                    ).toLowerCase().includes(search.toLowerCase())));
        }
    },
    getPremixTmr(state) {
        return(feedId) => {
            if (!feedId)
                return null
            else
                return state.TMRs.find(t => t.premixkey === feedId)
        }
    },
    getTMR(state) {
        const defaultTMR = {
            Id: null,
            code: null,
            name: "",
            inactive: false,
            premixkey: "",
            version: 1,
            doseweight: 1,
            modified: Date(Date.now()),
            feeds: []
          };
        return (tmrId) => {
            if (tmrId)
                return  state.TMRs.find((t) => {
                    return t.Id === tmrId
                })
            else
                return defaultTMR;
            }
        },
    getTmrNameFromCode(state) {
        return (code) => {
        if (code == undefined || code == null)
            return "";
        else
            return state.TMRs.find((t) => {
                return t.code == code
            }).name
        }
    },
    getTmrFromCode(state) {
        return (code) => {
            return state.TMRs.find((t) => {
                return t.code == code
            })
        }
    },
    getTMRDoseWeight() {
        return (feeds) => {
            if (feeds && feeds.length >0) {
                let dw =  feeds.reduce(function (a, f) {
                    return isNaN(Number(f["qty"])) ? a : a + Number(f["qty"]);
                }, 0);
                return Math.round(dw * 1000) / 1000
            } else
                return 0;
        }
    },
    getDosesFromQty(state, getters) {
        return (qty, tmrId) => {
            let tmr = state.TMRs.find((t) => t.Id == tmrId);
            if (tmr && tmr.feeds ) {
                let dw = getters.getTMRDoseWeight(tmr.feeds);
                return (dw == 0) ? 0 : Math.round(qty/dw * 10) / 10;
            } else {
                return 0;
            }
        }
    },
    getGroups(state) {
        return state.Groups.sort((grpA, grpB) => {
            return grpA.code < grpB.code ? -1 : grpA.code > grpB.code ?  1 : 0;
        })
    },
    getGroupsSearch(state) {
        return(search) => {
            return state.Groups.sort((grpA, grpB) => {
                return grpA.code < grpB.code ? -1 : grpA.code > grpB.code ?  1 : 0;
            })
            .filter(g => (g.active || search ))
            .filter(g => (!search || (g.code + g.name + (g.translatedGroupType || g.groupType)
                                 + g.defaultTMR.code + (g.secondTMR.code || '')
                    ).toLowerCase().includes(search.toLowerCase()) ));
        }
    },
    getMiniGroups(state) {
        let miniGroups = [];
        state.Groups.sort((grpA, grpB) => {
            return grpA.code < grpB.code ? -1 : grpA.code > grpB.code ?  1 : 0;
        }).forEach(grp => {
            if (grp.defaultTMR.code) {
                miniGroups.push({...grp,  tmrCode: grp.defaultTMR.code})
            } else {
                miniGroups.push({ ...grp, tmrCode: "" })
            }

            if (grp.secondTMR.code) {
                miniGroups.push({...grp,  tmrCode: grp.secondTMR.code})
            }
        });
        return miniGroups;
    },
    getGroup(state) {
        const defaultGrp ={
            Id: null,
            code: "",
            name: "",
            active: true,
            groupType: "unspecified",
            hungerPercent: 100,
            cowCount: 1,
            operNote: null,
            defaultTMR: {
                code: null,
                dailyPercent: 100
            },
            secondTMR: {
                code: null,
                dailyPercent: 0
            },
            weeklyDelivery: [1, 1, 1, 1, 1, 1, 1]
        };
        return (groupId) => {
            if (groupId)
                return state.Groups.find((g) => g.Id === groupId );
            else
                return defaultGrp;
        }
    },
    getWagons(state) {
        //return state.Wagons
        let _wagons = [];
        if (state.Wagons == undefined) return []
        state.Wagons.forEach((w)=> {
            for(var x in (w.onlyForDays || [1,2,3,4,5,6,7])) {
                if (state.selectedDays.includes(w.onlyForDays[x])){
                    _wagons.push(w);
                    break;
                }
            }
        });
        return _wagons.sort((a, b) => {
                return a.order - b.order;
        })
    },
    getWagon(state) {
        return (wagonId) => {
            if (wagonId)
                return  state.Wagons.find((w) => {
                    return w.id === wagonId
                });
            else
                return {
                    name: "",
                    order: 0,
                    onlyForDays: [],
                    lastMade: Date("2000-01-01T00:00:00"),
                    lastMadeId: "",
                    lastModified: Date.now(),
                    groups: [],
                    tmr: []
                };
        }
    },
    weekdayQty() {
        return (wagon) => {
            let _weekdayQty = [0, 0, 0, 0, 0, 0, 0];
            let _makeDays = [0, 0, 0, 0, 0, 0, 0];
            wagon.onlyForDays.forEach((i) => _makeDays[i-1] = 1);

            wagon.groups.forEach((x) => {
                x.dailyQty.forEach((qty, i) =>
                    _weekdayQty[i] += (qty * _makeDays[i])
                )
            });
            return _weekdayQty;
        }
    },
    getSelectedDays(state) {
        return state.selectedDays
        .sort((a, b) => {
            return a < b ? -1 : 1;
        })
    },
    groupsInWagons(state) {
        let groups = [];
        state.Wagons.forEach(function (wgn) {
            wgn.groups.forEach(function(wGrp){
                let indx = groups.findIndex((x) => x.code == wGrp.code && x.tmrCode == wgn.tmr.code);
                if (indx == -1)
                    groups.push({grpCode: wGrp.code, tmrCode: wgn.tmr.code, wagonsArr: [wgn.name]});
                else
                    groups[indx].wagonsArr.push(wgn.name);
            });
        });
        return groups;
    },
    allowGroupInWagon(state) {
        return (wagonId, groupId) => {
            if (wagonId == "ADD")
                return "yes";
            let wagon = state.Wagons.find((w) => w.id == wagonId);
            let group = state.Groups.find((g) => g.id == groupId);
            if (wagon.tmr.code != group.defaultTMR.code && wagon.tmr.code != group.secondTMR.code )
                return this.$t('this-wagon-makes-a-different-tmr');
            if (wagon.onlyForDays.some((d) => group.weeklyDelivery[d-1] == 0))
                return this.$t('this-wagon-is-made-on-days-with-a-group-schedule-of-0');
            return "yes";
        }
    },
    groupsInWagonsCount(state) {
        return (groupCode, tmrCode) => {
            let count = 0;
            state.Wagons.forEach(function (wgn) {
                let indx = wgn.groups.findIndex((x) => x.code == groupCode && wgn.tmr.code == tmrCode);
                if (indx >= 0)
                    count++;
            });
            return count;
        }
    },
    wagonStatus(state) {
        return (status) => {
            return state.wagonStatus[status];
        }
    },
    getMaterialsPlan(state, getters) {
        return (startDay, days)  => {
            if (!startDay) startDay = new Date();
            if (!days) days = 1;
            let weekDay = startDay.getDay() + 1;
            let _materials = [];
            while(days > 0) {
                state.Wagons.forEach(function (wgn) {
                    if (wgn.tmr && wgn.onlyForDays.includes(weekDay)) {
                        let tmr = getters.getTMR(wgn.tmr.documentID);
                        if (tmr) {
                            let wgnQtyInDoses = wgn.groups.reduce((a, g) => {
                                return isNaN(Number(g["qty"])) ? a : a + Number(g["qty"]);
                            }, 0) / (tmr.doseweight || 1);
                            if (tmr.feeds )
                                tmr.feeds.forEach((feed) => {
                                        let matIndex = _materials.findIndex((x) => x.code == feed.code);
                                        if ( matIndex == -1 )
                                            matIndex =  _materials.push({code: feed.code, name: feed.name, qty: 0 }) - 1;

                                        _materials[matIndex].qty += Math.round(feed.qty * wgnQtyInDoses);
                                });
                        }
                    }

                })
                days -= 1;
                weekDay += 1;
                if (weekDay > 7) weekDay = 1;
            }
            return (_materials);
        }
    },
    getWeightUnit(state) {
        if (state.Profile.valueScaleItems)
            return state.Profile.valueScaleItems
        else
            return 'Kg'
    },

    //====================== dashboard data =============
    getTodayGraph (state) {
        return  {
            labels: state.labels,
                datasets: [
                    {
                        label: i18n.t('Made'),
                        backgroundColor: "#f87979",
                        data: state.todayMake
                    },
                    {
                        label: i18n.t('Deliver'),
                        backgroundColor: "#5544aa",
                        data: state.todayDeliver
                    }
                ]
        }
    },
    getYesterdayGraph(state) {
        return {
            labels: state.labels,
            datasets: [
                {
                    label: i18n.t('Made'),
                    backgroundColor: "#f87979",
                    data: state.yesterdayMake
                },
                {
                    label: i18n.t('Deliver'),
                    backgroundColor: "#5544aa",
                    data: state.yesterdayDeliver
                }
            ]
        }
    },
    //====================== Equipment data =============
    getEquipmentList(state) {
        return state.Equipments.sort((a) => a.active ? -1 : 1 );
    },

    getEquipInfo(state) {
        return (index) => {
            const temp = _.omit(state.Equipments[index], ["Id", "lastSync", "display", "name", "active", "docId", "activations"]);
            return Object.keys(temp).sort().reduce((accumulator, currentValue) => {
                accumulator[currentValue] = temp[currentValue];
                return accumulator;
            }, {})
        }
    },
    getLastSync(state) {
        return (index) =>
            state.Equipments[index].lastSync;
    },
    getEquipmentName(state) {
        return (index) =>
            state.Equipments[index].name;
    },
    getEquipmentActive(state) {
        return (index) =>
            state.Equipments[index].active || false;
    },

    //=========================================================
    getLocaleFromLang(state) {
        return (lang) => {
        if (lang && lang in state.languages)
            return state.languages[lang];
        }
    },

    //===================== Recipe data ======================
    getRecipe(state) {
        const defaultRecipe = {
            name: '',
            targetGroup: '',
            groupsUse: [],
            archive: false,
            source: 'Manual',
            notes: '',
            nutrition: nutritionEmptyData
        };
        return (recipeId) => {
            if (recipeId)
                return  state.Recipes.find((r) => {
                    return r.id === recipeId
                });
            else
                return { ...defaultRecipe, code: state.Profile.nextRecipeNo };
        }
    },
    getNextRecipeNo(state) {
        return state.Profile.nextRecipeNo;
    },
    getRecipes(state) {
        // return state.Recipes;
        return (filter, search) => {
            return state.Recipes.sort((recipeA, recipeB) => {
            return recipeA.code < recipeB.code ? -1 : recipeA.code > recipeB.code ?  1 : 0;
            })
        .filter(r => r.targetGroup == filter || !filter)        //filter on target group when 'filter' provided
        .filter(r => !r.archive || search)                      //include archive only when 'search' is provided
        .filter(r => !search || (r.code + r.name + r.source).toLowerCase().includes(search));
        }
    },
    getGroupTypesForDD(state) {
        return state.GroupTypes.map(x => {
            return { text: i18n.t(x), value: x == 'Unspecified' ?  '': x }
        });
    }

}
